import { Component } from '@angular/core';

@Component({
    selector: 'green-mustache-brush-svg',
    templateUrl: '../../../../../../src/assets/svgs/green-mustache-brush.svg',
    styleUrls: ['../svg.component.scss']
})
export class GreenMoustacheBrushSVG {

}